export default {"src":"/_next/static/media/kids.196eff02.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};